var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-xs-12 col-md-10" },
    _vm._l(_vm.posts, function(post) {
      return _c(
        "div",
        { key: post.id, staticClass: "col-sm-10 col-sm-offset-2 blogItem" },
        [
          _c("div", { staticClass: "card-content" }, [
            _c("h2", { domProps: { innerHTML: _vm._s(post.title.rendered) } }),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(post.excerpt.rendered) }
              })
            ]),
            _vm._v(" "),
            _c(
              "footer",
              { staticClass: "card-footer" },
              [
                _c(
                  "router-link",
                  {
                    attrs: { to: { path: "/post", query: { postId: post.id } } }
                  },
                  [_vm._v("Read More")]
                )
              ],
              1
            )
          ])
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a600d9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a600d9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/js/components/PostList.vue
// module id = 389
// module chunks = 0